export default __webpack_public_path__ + "static/media/minisite-pagetype-product_details.0f95383a.svg";